import script from "./SearchResult.vue?vue&type=script&setup=true&lang=js"
export * from "./SearchResult.vue?vue&type=script&setup=true&lang=js"

import "./SearchResult.vue?vue&type=style&index=0&id=07eb6634&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-07eb6634"]])

export default __exports__